<template>
  <div class="d-flex header-wrapper">
    <div class="sku-table-title mr-1">
      {{ $l('title_spec_table_info') || '备货产品规格明细' }}
    </div>
  </div>
</template>

<script>
// 初始表单
export default {
  props: {
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      form: {},
    }
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
.header-wrapper {
  align-items: center;
}
.sku-table-title {
  color: #2b3447;
  font-size: 18px;
  font-weight: 600;
}
</style>
